
function NoPage404 () {
    return (
        <>
            <h1>Error 404: Page not found.</h1>
        </>
    )
}

export default NoPage404;